// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__BWNsd","spinner":"Loader_spinner__a2xc9","spinGrowShrink":"Loader_spinGrowShrink__LDhMQ"};